const configDevelopment = {
  graphqlUri: 'http://localhost:3000/graphql',
  frontProtocol: 'https://',
  frontUriSuffix: '.stage.assolib.net',
}

const configStage = {
  graphqlUri: 'https://stage.api.assolib.net/graphql',
  frontProtocol: 'https://',
  frontUriSuffix: '.stage.assolib.net',
}

const configProduction = {
  graphqlUri: 'https://api.assolib.net/graphql',
  frontProtocol: 'https://',
  frontUriSuffix: '.assolib.fr',
}
console.log('process.env.REACT_APP_ENV', process.env.REACT_APP_ENV)

let configToUse = configDevelopment
if (process.env.REACT_APP_ENV === 'production') {
  configToUse = configProduction
} else if (process.env.REACT_APP_ENV === 'stage') {
  configToUse = configStage
}
console.log('configToUse', configToUse)
export const config = configToUse
